var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSongs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0;fill:#808080;}\r\n\t.st1{fill:#808080;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.5,22.3c0,0.1,0,0.2,0,0.2c0,1.2-1.4,2.3-3.1,2.3s-3.1-1-3.1-2.3s1.4-2.3,3.1-2.3c0.5,0,0.9,0.1,1.4,0.2 l0.7,0.2v-6l-9.2,1.1v7.3v0.1v0.1c0,0.1,0,0.2,0,0.2c0,1.2-1.4,2.3-3.1,2.3s-3.1-1-3.1-2.3s1.4-2.3,3.1-2.3c0.5,0,0.9,0.1,1.4,0.2 l0.7,0.2V14c0-0.4,0.3-0.7,0.6-0.7l10.7-1.2v10V22.3L26.5,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4,14.8c0-1.3,1.3-2.3,3-2.3c0.5,0,0.9,0.1,1.3,0.2L9,13V5.6c0-0.4,0.3-0.7,0.6-0.7l6.9-0.8V5 c0,0.4-0.3,0.7-0.6,0.7L10,6.4v8v0.1v0.1c0,0.1,0,0.2,0,0.2C10,16,8.7,17,7,17S4,16,4,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,30.1L32,30.1l-0.1,0.1c-0.3,1-1.5,1.8-2.9,1.8c-1.7,0-3-1-3-2.2s1.3-2.3,3-2.3c0.5,0,0.9,0.1,1.3,0.2 L31,28v-7h1V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,6.5c0.3,0,0.5-0.2,0.5-0.5V5.5C29.5,5.3,29.3,5,29,5s-0.5,0.2-0.5,0.5V6C28.5,6.3,28.7,6.5,29,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,7.5h0.5C30.8,7.5,31,7.3,31,7c0-0.3-0.2-0.5-0.5-0.5H30c-0.3,0-0.5,0.2-0.5,0.5C29.5,7.3,29.7,7.5,30,7.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,7.5H28c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5h-0.5C27.2,6.5,27,6.8,27,7 C27,7.3,27.2,7.5,27.5,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,7.5c-0.3,0-0.5,0.2-0.5,0.5v0.5C28.5,8.8,28.7,9,29,9s0.5-0.2,0.5-0.5V8C29.5,7.8,29.3,7.5,29,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.5,27.5V28c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-0.5C7.5,27.3,7.3,27,7,27S6.5,27.3,6.5,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,28.5H8c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h0.5C8.8,29.5,9,29.3,9,29S8.8,28.5,8.5,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,28.5H5.5C5.2,28.5,5,28.8,5,29s0.2,0.5,0.5,0.5H6c0.3,0,0.5-0.2,0.5-0.5S6.3,28.5,6,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,29.5c-0.3,0-0.5,0.2-0.5,0.5v0.5C6.5,30.8,6.7,31,7,31s0.5-0.2,0.5-0.5V30C7.5,29.8,7.3,29.5,7,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.8,9.5C21.4,9.5,22,9,22,8.3C22,7.6,21.4,7,20.8,7s-1.3,0.6-1.3,1.3C19.5,9,20.1,9.5,20.8,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.8,28c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3S16,30,16,29.3S15.4,28,14.8,28z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongs);
export default __webpack_public_path__ + "static/media/songs.07de67be.svg";
export { ForwardRef as ReactComponent };